import {useEffect, useState} from 'react';
import {a, useSpring} from 'react-spring';

export const AnimatedNumber = ({ value, children = '', decimal = 1, className = '' }) => {
  const [stop, setStop] = useState(null)
  const [{ number }, api] = useSpring(() => ({ from: { number: 0 }, to: { number: Number(value) }, onRest() {
      setStop(true)
    } }));

  useEffect(() => {
    if (!isNaN(value))api.start({ number: Number(value) });
    else api.stop()
    return () => {};
  }, [value]);

  return (
      <div className={className}>
        {isNaN(value)?"- ":
            stop?(value === 0 || value === 100?value.toFixed(0):value.toFixed(decimal)):<a.span>{number.to((num) => num.toFixed(decimal))}</a.span>
        }

        {children}

      </div>
  );
};

export default AnimatedNumber;
